let loadPromise = null;
let loadedKey = null;

export function loadRecaptcha(siteKey) {
    if (!siteKey) {
        return Promise.reject(new Error('Missing reCAPTCHA site key'));
    }

    if (window.grecaptcha?.execute) {
        return new Promise(resolve => {
            window.grecaptcha.ready(() => resolve(window.grecaptcha));
        });
    }

    if (loadPromise && loadedKey === siteKey) {
        return loadPromise;
    }

    loadedKey = siteKey;
    loadPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector(
            'script[src*="recaptcha/api.js"]'
        );

        if (existing) {
            window.grecaptcha?.ready(() => resolve(window.grecaptcha));

            return;
        }

        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
            window.grecaptcha.ready(() => resolve(window.grecaptcha));
        };
        script.onerror = () => {
            loadPromise = null;
            reject(new Error('reCAPTCHA failed to load'));
        };
        document.head.appendChild(script);
    });

    return loadPromise;
}

export function executeRecaptcha(siteKey, action = 'submit') {
    return loadRecaptcha(siteKey).then(grecaptcha =>
        grecaptcha.execute(siteKey, { action })
    );
}

export function preloadRecaptchaOnInteraction(root, siteKey) {
    if (!root || !siteKey) {
        return;
    }

    const preload = () => {
        loadRecaptcha(siteKey).catch(() => {});
    };

    root.addEventListener('focusin', preload, { once: true, passive: true });
    root.addEventListener('mouseenter', preload, { once: true, passive: true });
}
